module.exports = __webpack_public_path__ + "img/hc_pro_three_8.ec5673ab.jpg";